__turbopack_context__.v({
  "article": "jYPBKW_article",
  "articleContent": "jYPBKW_articleContent",
  "body": "jYPBKW_body",
  "card": "jYPBKW_card",
  "cardCopy": "jYPBKW_cardCopy",
  "cardDate": "jYPBKW_cardDate",
  "cardImage": "jYPBKW_cardImage",
  "cardLink": "jYPBKW_cardLink",
  "cardTitle": "jYPBKW_cardTitle",
  "excerpt": "jYPBKW_excerpt",
  "featuredImage": "jYPBKW_featuredImage",
  "grid": "jYPBKW_grid",
  "metadata": "jYPBKW_metadata",
  "pagination": "jYPBKW_pagination",
  "posts": "jYPBKW_posts",
  "postsContent": "jYPBKW_postsContent",
  "readingTime": "jYPBKW_readingTime",
  "share": "jYPBKW_share",
});
